import React from 'react';
import noop from 'mn-utils/noop';
import {Grid} from "@material-ui/core";
import {SubmitBtnMerchant} from "../FormSubmitBtn";
import {FormAdditionalBtnMerchant} from "../FormAdditionalBtn";
// const FormSubmitBtn = require('../FormSubmitBtn');
// const FormAdditionalBtn = require('../FormAdditionalBtn');

const formFooterCtor = ({SubmitBtn, AdditionalBtn}) => (props) => {

  const {
    spacing = 2,
    submitBtnData = {},
    additionalBtnsList = [],
    additionalNodesList = []
  } = props;

  const {
    formCtx,
    changesCheckDisabled,
    disabled: submitBtnDisabled,
    text: submitBtnText
  } = submitBtnData;

  return (
    <Grid
      container
      spacing={spacing}
    >
      <Grid item sm={6} xs={12}>
        <SubmitBtn
          formCtx={formCtx}
          disabled={submitBtnDisabled}
          changesCheckDisabled={changesCheckDisabled}
        >
          {submitBtnText}
        </SubmitBtn>
      </Grid>
      {additionalBtnsList.map(({text, onClick = noop, disabled}, id) => (
        <Grid key={id} item sm={6} xs={12}>
          <AdditionalBtn onClick={onClick} formCtx={formCtx}>
            {text}
          </AdditionalBtn>
        </Grid>
      ))}
      {additionalNodesList.map((item, index) => (
        <div key={index} className="ph27">
          {item}
        </div>
      ))}
    </Grid>
  )
};

export const FormFooterMerchant = formFooterCtor({
  SubmitBtn: SubmitBtnMerchant,
  AdditionalBtn: FormAdditionalBtnMerchant
})
